module.exports = __webpack_public_path__ + "/img/b5d1e989d3769f4c7f54efa28d1fb3ed.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/mk_img_01_m.png
 ** module id = 30
 ** module chunks = 0 4 5
 **/